import * as TradeActions from 'actions/trade';
import { isAuthenticated, markIntroAsSeen, getKycStatus } from 'actions/user';
import { closePopup } from 'actions/wallet';
import Trade from 'components/trade/trade';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectedProductState, lastTradePriceSelector } from 'selectors';
import IState, { ICustomDispatch } from 'types/Istore';

const mapStateToProps = (state: IState) => {
  return {
    user: state.user,
    selected_product: selectedProductState(state),
    isLoggedIn: isAuthenticated(state.user),
    lastTradedPrice: lastTradePriceSelector(),
    stateContractType: state.trade.selectedContractType,
  };
};

const mapDispatchToProps = (dispatch: ICustomDispatch<IState>) =>
  bindActionCreators(
    { ...TradeActions, markIntroAsSeen, closePopup, getKycStatus },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Trade);
